// extracted by mini-css-extract-plugin
export default {"modalOverlay":"xJ-z","modalContent":"yJ-z","header":"zJ-z","close":"AJ-z"};